<template>
  <v-tabs
    v-model="active"
    color="gray-7"
    centered
  >
    <v-tab
      v-for="item in ['information', 'rides']"
      :key="item"
      ripple
      class="pl-0"
      style="width: 50%"
    >
      {{ $t(`${namespace}.${item}`) }}
    </v-tab>

    <v-tab-item>
      <v-card class="pa-4 overflow--y" :style="`height: ${contentHeight}px`" flat>
        <TabInfo
          v-if="hasRole('costCenter', 'ROLE_GET_COSTCENTER_ID')"
          :data="data"
        />

        <EmptyState
          v-else
          image="employee"
          :imageSize="120"
          class="px-4"
        >
          <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
        </EmptyState>
      </v-card>
    </v-tab-item>

    <v-tab-item>
      <v-card flat>
        <RideList
          :data="data"
          :drawerType="drawerType"
          :filters="filters"
          @change="change"
        />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { hasRole } from 'utils/functions'
import { calcContentHeight } from 'corp-front-vue-commons/src/utils/functions'
import TabInfo from './TabInfo'
import RideList from 'components/GlobalDrawer/RideList'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Tabs',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    TabInfo,
    RideList,
    EmptyState
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.costCenter.tabs',
      active: 0,
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    change (val) {
      this.$emit('change', val)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss">
.v-tabs.v-tabs-reports--drawer {

  .v-tabs__container.v-tabs__container--centered {
    margin-left: 0;
  }
}

.name {
  display: block;
  font-family: $title-font;
  font-weight: 700;
  line-height: 1.43;
}

.item__label,
.item__text {
  display: block;
}

.item__label {
  color: $gray-6;
  font-size: $base-font-size - 1px;
}
</style>
